const FAQ_ITEMS = [
  {
    q: '黑料视频是什么类型的平台？',
    a: '黑料视频是一个娱乐资讯视频聚合平台，提供黑料视频在线观看与黑料视频下载一站式服务。平台汇聚娱乐圈、网红圈、综艺圈等多个领域的独家爆料和热门视频内容，每日更新超过200条最新资源。',
  },
  {
    q: '如何在黑料视频在线观看内容？',
    a: '访问黑料视频官网最新地址，进入首页即可浏览推荐的热门黑料视频。你可以通过专题分类、热门话题或排行榜快速找到感兴趣的内容，点击即可在线观看。所有视频均支持高清流畅播放。',
  },
  {
    q: '黑料视频支持下载吗？如何下载？',
    a: '支持。你可以通过黑料视频官网的下载功能或下载黑料视频手机App来实现离线观看。手机App支持iOS和Android双平台，安装后在视频详情页点击下载按钮即可将黑料视频保存到本地。',
  },
  {
    q: '黑料视频的官网地址在哪里可以找到？',
    a: '本页面即为黑料视频的官方网站首页，请收藏当前页面地址以便随时访问。我们也会定期更新最新地址入口，确保用户能够稳定访问黑料视频在线观看服务。建议同时下载手机App作为备用访问方式。',
  },
  {
    q: '黑料视频的内容更新频率是怎样的？',
    a: '黑料视频每天更新超过200条新鲜内容，覆盖娱乐圈最新爆料、网红动态追踪、综艺节目内幕等多个板块。我们的编辑团队7x24小时不间断追踪全网热点，确保用户第一时间获取最新黑料视频资源。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">关于黑料视频的常见疑问，这里都有详细解答</p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {FAQ_ITEMS.map((item, idx) => (
            <details key={idx} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden" open>
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{item.q}</h3>
                <div className="w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-600 group-open:rotate-180 transition-transform text-sm"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-700 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}